import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AlchemistAbandoned4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ALCHEMIST_ABANDONED4;
}

export default AlchemistAbandoned4PoiTileEntity;
